export default __webpack_public_path__ + "static/votingfunds-7b2803fe8326707d95add9612a298b6b.png";